module.exports = __webpack_public_path__ + "static/scheiben-mobile-028e739f1021962ef3f282cdaadc1a82.jpg";